import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, EffectCoverflow } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import { NavLink } from "react-router-dom";

// Using existing images from the project
// import rightEle from "../../images/aboutUs/elegent.png";
import galleryImg1 from "../../images/gallery/gallery1.png";
// import galleryImg2 from "../../images/gallery/gallery2.png";
// import galleryImg3 from "../../images/gallery/gallery3.png";
// import galleryImg4 from "../../images/gallery/gallery4.png";
// import galleryImg5 from "../../images/gallery/gallery5.png";
// import galleryImg6 from "../../images/gallery/gallery6.png";
// import galleryImg7 from "../../images/gallery/gallery7.png";
// import galleryImg8 from "../../images/gallery/gallery8.png";
// import galleryImg9 from "../../images/gallery/gallery9.png";
// import galleryImg10 from "../../images/gallery/gallery10.png";

// New destination images
import somnathTemple1 from "../../images/exp/somnath-temple1.jpg";
import somnathTemple2 from "../../images/exp/somnath-temple2.jpg";
import somnathTemple3 from "../../images/exp/somnathTemple3.png"
import somnathTemple4 from "../../images/exp/somnathTemple4.png"
import diu1 from "../../images/exp/diu-1.jpeg";
import diu2 from "../../images/exp/diu-2.jpeg";
import diu3 from "../../images/exp/diu-3.jpeg";
import droneshwarDam from "../../images/exp/DroneshwarDam-1.webp";
import tapkeshwar from "../../images/exp/tapkeshwar-1.jpg";
import jamzir1 from "../../images/exp/jamzir1.png";
import jamzir2 from "../../images/exp/jamzir2.png";
import jamzir3 from "../../images/exp/jamzir3.png";
import jamzir4 from "../../images/exp/jamzir4.png";
import jamzir from "../../images/exp/jamzir.png";
import kankai from "../../images/exp/kankai.png";
import kankai1 from "../../images/exp/kankai1.png";
import kankai2 from "../../images/exp/kankai2.png";
import kankai3 from "../../images/exp/kankai3.png";
import safari from "../../images/exp/safari.png";
import safari1 from "../../images/exp/safari1.png";
import safari2 from "../../images/exp/safari2.png";
import safari3 from "../../images/exp/safari3.png";
import safari4 from "../../images/exp/safari4.png";
import diu4 from "../../images/exp/diu4.png";
import droneshwarDam1 from "../../images/exp/droneshwar1.png";
import droneshwarDam2 from "../../images/exp/droneshwar2.png";
import tapkeshwar1 from "../../images/exp/tapkeshwar1.png";



const AreaExplorer = () => {
  const observerRef = useRef(null);
  
  useEffect(() => {
    // Initialize Intersection Observer for fade-in animations
    observerRef.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, { threshold: 0.1 });
    
    // Observe all fade-in elements
    const fadeElements = document.querySelectorAll('.fade-in, .staggered-fade');
    fadeElements.forEach(el => {
      observerRef.current.observe(el);
    });
    
    return () => {
      if (observerRef.current) {
        fadeElements.forEach(el => {
          observerRef.current.unobserve(el);
        });
      }
    };
  }, []);

  // Main area attractions with expanded data
  const areaAttractions = [
    
    {
      id: "waterfall",
      title: "Jamzir Waterfall",
      distance: "14 KM from Gir Glades",
      description: "Experience the serene beauty of Jamzir Waterfall — a hidden gem in Gir, offering a refreshing retreat surrounded by lush greenery and natural rock formations.",
      longDescription: "Tucked away in the forest, Jamzir waterfall creates a mesmerizing cascade where the sound of water hitting the rocks creates a natural symphony that complements the forest sounds. The cool mist from the falls provides welcome relief on hot days.",
      mainImage: jamzir,
      galleryImages: [jamzir2, jamzir3, jamzir1],
      features: ["Nature Photography", "Bird Watching", "Picnic Spot", "Swimming (seasonal)", "Hiking"],
      bestTime: "Post-monsoon season (August to October)",
      difficulty: "Requires short trek through river bed"
    },
    {
      id: "kankai",
      title: "Kankai Temple",
      distance: "15 KM from Gir Glades",
      description: "Discover the spiritual heritage at Kankai Temple, an ancient shrine dedicated to Goddess Kankai located inside the reserve forest.",
      longDescription: "Kankai Temple holds deep significance in local culture and spirituality, wherein the temple architecture showcases traditional craftsmanship with intricate carvings and peaceful surroundings. Visitors can participate in daily rituals or simply absorb the tranquil environment.",
      mainImage: kankai,
      galleryImages: [kankai1, kankai2, kankai3],
      features: ["Spiritual Visit", "Cultural Experience", "Historical Site", "Architecture", "Meditation"],
      bestTime: "Early mornings or during local festivals",
      difficulty: "Easily accessible by car with paved pathways"
    },
    {
      id: "safari",
      title: "Gir National Park Safari",
      distance: "1 hour drive from Gir Glades",
      description: "Embark on an exciting jungle safari through the famous Gir National Park, the last abode of Asiatic lions, and witness the majestic creatures in their natural habitat.",
      longDescription: "Gir National Park's safari is the highlight of any visit to this region. Professional guides take you through designated routes where you might spot the magnificent Asiatic lion, leopards, deer, jackals, and hundreds of bird species. Each safari is unique, as wildlife sightings depend on many natural factors.",
      mainImage: safari,
      galleryImages: [safari1, safari2, safari4],
      features: ["Wildlife Safari", "Lion Sighting", "Nature Tour", "Bird Watching", "Photography"],
      bestTime: "Early morning or late afternoon safaris",
      difficulty: "Guided tour in safari vehicles"
    },
    {
      id: "somnath",
      title: "Somnath Temple",
      distance: "60Kms 0r 1.2 hours drive from Gir Glades",
      description: "Visit the magnificent Somnath Temple, one of the twelve sacred Jyotirlingas of Lord Shiva, standing majestically on the shores of the Arabian Sea.",
      longDescription: "Somnath Temple is one of India's most revered pilgrimage sites, steeped in history and spirituality. The temple has been rebuilt multiple times throughout history and stands as a testament to faith and resilience. The current structure showcases beautiful architecture with intricate carvings and offers stunning views of the Arabian Sea. The temple's significance in Hindu mythology and its peaceful atmosphere make it a must-visit spiritual destination.",
      mainImage: somnathTemple1,
      galleryImages: [somnathTemple2, somnathTemple3, somnathTemple4],
      features: ["Sacred Pilgrimage", "Historical Architecture", "Sea Views", "Spiritual Experience", "Photography"],
      bestTime: "Early morning or evening for prayers and sunset views",
      difficulty: "Easily accessible by car with paved pathways"
    },
    {
      id: "diu",
      title: "Diu Island",
      distance: "1 hour drive from Gir Glades",
      description: "Explore the charming coastal town of Diu with its pristine beaches, Portuguese colonial architecture, historic forts, and vibrant culture.",
      longDescription: "Diu is a former Portuguese colony that offers a perfect blend of history, culture, and natural beauty. The island features stunning beaches with golden sand and clear blue waters, perfect for relaxation and water sports. Explore the magnificent Diu Fort with its panoramic ocean views, visit the beautiful St. Paul's Church with Portuguese architecture, and wander through the charming streets lined with colorful houses. The laid-back atmosphere and scenic beauty make Diu an ideal getaway.",
      mainImage: diu1,
      galleryImages: [diu2, diu3, diu4],
      features: ["Beach Paradise", "Portuguese Heritage", "Historic Forts", "Water Sports", "Cultural Experience"],
      bestTime: "October to March for pleasant weather",
      difficulty: "Easy access by road, walkable town center"
    },
    {
      id: "droneshwar",
      title: "Droneshwar Dam",
      distance: "25 minutes drive from Gir Glades",
      description: "Discover the serene Droneshwar Dam, a peaceful water reservoir surrounded by hills and offering excellent opportunities for nature photography and bird watching.",
      longDescription: "Droneshwar Dam is a hidden gem located amidst rolling hills and lush greenery. This tranquil spot offers a perfect escape into nature with its calm waters reflecting the surrounding landscape. The area around the dam is ideal for nature walks, bird watching, and photography. During monsoon season, the overflowing dam creates beautiful waterfalls, making it even more spectacular. The peaceful environment and scenic beauty make it a perfect spot for meditation and relaxation.",
      mainImage: droneshwarDam,
      galleryImages: [droneshwarDam, droneshwarDam1, droneshwarDam2],
      features: ["Nature Photography", "Bird Watching", "Peaceful Environment", "Scenic Views", "Monsoon Waterfalls"],
      bestTime: "Post-monsoon season for waterfalls, winter for clear views",
      difficulty: "Moderate drive through hilly terrain, short walk to viewpoints"
    },
    {
      id: "tapkeshwar",
      title: "Tapkeshwar Temple",
      distance: "20 min drive and 20 min trek from Gir Glades",
      description: "Visit the ancient Tapkeshwar Temple, a sacred Shiva temple known for its natural cave setting and spiritual significance in the region.",
      longDescription: "Tapkeshwar Temple is an ancient shrine dedicated to Lord Shiva, nestled in a natural cave formation that adds to its mystical appeal. The temple is known for its spiritual atmosphere and the natural acoustics of the cave that enhance the chanting and prayers. The journey to the temple takes you through scenic countryside, and the temple itself offers a unique blend of natural beauty and spiritual energy. Local devotees believe that prayers offered here are especially powerful, making it an important pilgrimage site in the region.",
      mainImage: tapkeshwar,
      galleryImages: [tapkeshwar,tapkeshwar1,tapkeshwar1],
      features: ["Ancient Cave Temple", "Spiritual Experience", "Natural Acoustics", "Pilgrimage Site", "Scenic Route"],
      bestTime: "Early morning for peaceful prayers, avoid peak summer",
      difficulty: "Accessible by car, minimal walking required"
    }
  ];

  return (
    <div className="bg-[#FBF8F3] py-16 px-4 md:px-8">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-xl text-[#585858] poppins-medium text-center fade-in">
          EXPLORE THE AREA
        </div>
        <div className="mt-2 tracking-wide mx-auto flex justify-center text-center md:w-[700px] md:leading-snug text-2xl md:text-[46px] font-bold text-[#672220] fade-in">
          Discover The Natural Beauty of Gir
        </div>

        {/* Lead-in text */}
        <div className="text-center max-w-[800px] mx-auto mt-8 mb-16 text-[#5A5A5A] fade-in">
          <p>Enriched with natural beauty, heritage, and unforgettable experiences waiting around every corner, the area surrounding Gir Glades is filled with must-visit attractions you must explore.</p>
        </div>

        {/* Main Featured Destinations */}
        <div className="space-y-32">
          {areaAttractions.map((attraction, index) => (
            <div 
              key={attraction.id} 
              id={attraction.id}
              className="fade-in"
            >
              {/* Full-width image with text overlay - showcase */}
              <div className="relative h-[400px] md:h-[500px] rounded-xl overflow-hidden shadow-xl mb-8">
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black opacity-70 z-10"></div>
                <img 
                  src={attraction.mainImage} 
                  alt={attraction.title} 
                  className="absolute w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 z-20 p-6 md:p-10 w-full md:w-2/3">
                  <h2 className="text-3xl md:text-4xl text-white font-bold mb-2">{attraction.title}</h2>
                  <p className="text-[#D1A752] mb-3">{attraction.distance}</p>
                  <p className="text-white text-lg md:text-xl opacity-90">{attraction.description}</p>
                </div>
              </div>

              {/* Content area */}
              <div className="md:flex gap-10">
                {/* Left column - text content */}
                <div className="md:w-1/2 staggered-fade">
                  <div className="activity-indicator mb-4"></div>
                  
                  <p className="text-[#5A5A5A] text-lg mb-8">
                    {attraction.longDescription}
                  </p>
                  
                  <h4 className="text-[#672220] font-semibold mb-2">Best Time to Visit</h4>
                  <p className="text-[#5A5A5A] mb-4">{attraction.bestTime}</p>
                  
                  <h4 className="text-[#672220] font-semibold mb-2">Accessibility</h4>
                  <p className="text-[#5A5A5A] mb-6">{attraction.difficulty}</p>
                  
                  <div className="flex flex-wrap gap-3 mb-8">
                    {attraction.features.map((feature, i) => (
                      <span 
                        key={i} 
                        className="bg-[#D1A752] bg-opacity-10 text-[#672220] px-4 py-2 rounded-full text-sm"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
                
                {/* Right column - image gallery */}
                <div className="md:w-1/2 mt-8 md:mt-0">
                  <Swiper
                    modules={[Autoplay, EffectCoverflow, Navigation, Pagination]}
                    effect="coverflow"
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView="auto"
                    coverflowEffect={{
                      rotate: 50,
                      stretch: 0,
                      depth: 100,
                      modifier: 1,
                      slideShadows: true,
                    }}
                    pagination={{ clickable: true }}
                    navigation={true}
                    autoplay={{
                      delay: 3500,
                      disableOnInteraction: false,
                    }}
                    className="rounded-xl"
                  >
                    <SwiperSlide style={{width: '70%'}}>
                      <div className="h-[300px] md:h-[400px] overflow-hidden">
                        <img
                          src={attraction.mainImage}
                          alt={attraction.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                    </SwiperSlide>
                    {attraction.galleryImages.map((img, i) => (
                      <SwiperSlide key={i} style={{width: '70%'}}>
                        <div className="h-[300px] md:h-[400px] overflow-hidden">
                          <img
                            src={img}
                            alt={`${attraction.title} - view ${i+1}`}
                            className="w-full h-full object-cover"
                          />
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  
                  {/* Small thumbnails row */}
                  <div className="flex justify-center gap-3 mt-4">
                    {attraction.galleryImages.map((img, i) => (
                      <div key={i} className="w-16 h-16 overflow-hidden rounded-md border-2 border-white shadow-sm">
                        <img 
                          src={img} 
                          alt={`${attraction.title} thumbnail ${i+1}`} 
                          className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              
              {/* Divider - only for non-last items */}
              {index < areaAttractions.length - 1 && (
                <div className="w-full flex justify-center mt-16">
                  <div className="w-16 h-1 bg-[#D1A752] opacity-30 rounded-full"></div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Quick Navigation */}
        <div className="mt-24 bg-white rounded-xl shadow-lg p-8 fade-in">
          <h3 className="text-2xl text-[#672220] font-bold mb-6 text-center">
            Jump to Destination
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            {areaAttractions.map(attraction => (
              <a 
                key={attraction.id}
                href={`#${attraction.id}`}
                className="bg-[#D1A752] bg-opacity-10 hover:bg-opacity-20 text-[#672220] px-6 py-3 rounded-full text-base transition-all flex items-center"
              >
                <span className="mr-2">{attraction.title}</span>
                <span className="text-xs opacity-70">{attraction.distance}</span>
              </a>
            ))}
          </div>
        </div>        
      </div>
    </div>
  );
};

export default AreaExplorer;